var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2256_7331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.17188 4.75C6.72416 4.75 7.17188 4.30228 7.17188 3.75C7.17188 3.19772 6.72416 2.75 6.17188 2.75C5.61959 2.75 5.17188 3.19772 5.17188 3.75C5.17188 4.30228 5.61959 4.75 6.17188 4.75Z",
    fill: "#2F3137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6719 4.75C11.2242 4.75 11.6719 4.30228 11.6719 3.75C11.6719 3.19772 11.2242 2.75 10.6719 2.75C10.1196 2.75 9.67188 3.19772 9.67188 3.75C9.67188 4.30228 10.1196 4.75 10.6719 4.75Z",
    fill: "#2F3137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.17188 9C6.72416 9 7.17188 8.55228 7.17188 8C7.17188 7.44772 6.72416 7 6.17188 7C5.61959 7 5.17188 7.44772 5.17188 8C5.17188 8.55228 5.61959 9 6.17188 9Z",
    fill: "#2F3137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6719 9C11.2242 9 11.6719 8.55228 11.6719 8C11.6719 7.44772 11.2242 7 10.6719 7C10.1196 7 9.67188 7.44772 9.67188 8C9.67188 8.55228 10.1196 9 10.6719 9Z",
    fill: "#2F3137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.17188 13.25C6.72416 13.25 7.17188 12.8023 7.17188 12.25C7.17188 11.6977 6.72416 11.25 6.17188 11.25C5.61959 11.25 5.17188 11.6977 5.17188 12.25C5.17188 12.8023 5.61959 13.25 6.17188 13.25Z",
    fill: "#2F3137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6719 13.25C11.2242 13.25 11.6719 12.8023 11.6719 12.25C11.6719 11.6977 11.2242 11.25 10.6719 11.25C10.1196 11.25 9.67188 11.6977 9.67188 12.25C9.67188 12.8023 10.1196 13.25 10.6719 13.25Z",
    fill: "#2F3137"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2256_7331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.421875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/drag.94c8166acc195c2fd94300ea161289fa.svg";
export { ForwardRef as ReactComponent };